import script from "./QActsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QActsItem.vue?vue&type=script&setup=true&lang=js"

import "./QActsItem.vue?vue&type=style&index=0&id=eb1e470a&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb1e470a"]])

export default __exports__